export function validateNewPassword(
  password: string,
  confirmation: string,
): string | null {
  const trimmed = password.trim();
  if (trimmed.length < 8) {
    return "La contraseña debe tener al menos 8 caracteres.";
  }
  if (trimmed !== confirmation.trim()) {
    return "Las contraseñas no coinciden.";
  }
  return null;
}
